@if (show) {
  @for (item of loaderItems(5); track item) {
    <table style="width: 100%">
      <thead>
        <tr>
          <th colspan="9">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{ height: '30px', margin: '0' }"
            />
          </th>
        </tr>
        <tr>
          <th colspan="9">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{ height: '20px', margin: '0' }"
            />
          </th>
        </tr>
      </thead>
      <tbody>
        @for (each of loaderItems(5); track each) {
          <tr>
            <td style="width: auto">
              <ngx-skeleton-loader
                count="1"
                appearance="line"
                [theme]="{ height: '50px' }"
              />
            </td>
            <td style="width: 10%">
              <ngx-skeleton-loader
                count="1"
                appearance="line"
                [theme]="{ height: '50px' }"
              />
            </td>
            @for (every of loaderItems(6); track every) {
              <td style="width: 4.188rem">
                <ngx-skeleton-loader
                  count="1"
                  appearance="line"
                  [theme]="{ height: '50px', width: '4.188rem' }"
                />
              </td>
            }
            <td style="width: 5%">
              <div style="display: flex; align-items: center">
                <ngx-skeleton-loader
                  count="1"
                  appearance="circle"
                  [theme]="{ height: '25px', width: '25px' }"
                />
                <ngx-skeleton-loader
                  count="1"
                  appearance="circle"
                  [theme]="{ height: '25px', width: '25px' }"
                />
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
}
